$(document).ready(function () {
    $('.control-panel_item_product').on('change', 'input[type="checkbox"]', function() {
        if($(this).is(':checked')) {
            $(this).closest('.control-panel_item_product').addClass('selected');
            $(this).closest('.control-panel_item').find('.transfer-block').slideDown(200);
        } else {
            $(this).closest('.control-panel_item_product').removeClass('selected'); 
            if(!$(this).closest('.control-panel_body').find('.control-panel_item_product.selected').length) {
                $(this).closest('.control-panel_item').find('.transfer-block').slideUp(200);          
            }
        }
    });

    $('#beforeDeleting').on('click', '.confirm-btn', function (e) {
        var newRadio = $('#beforeDeleting #project_id_new');
        var newInputText = $('#beforeDeleting input[name="new_name"]');
        if(!(newRadio.prop("checked") && newInputText.val() == "")){
            var url = $('#beforeDeleting').attr('data-action');
            var data = $('#beforeDeleting').find('input').serialize();
            var req = $.ajax({
                method: 'post',
                url: url,
                data: data
            });
            req.then(function(resp) {
                if (resp.success) {
                    if (resp.href) {
                        location.href = resp.href;
                    }

                    if (resp.html) {
                        if ($('.js-index-insert').length) {
                          $('.js-index-insert').html(resp.html);
                        }

                        $('#beforeDeleting').find('.close').trigger('click');
                    }
                }
            })
        }     
    });

    $('#deleteProject').on('click', '.confirm-btn', function (e) {
        var url = $('#deleteProject').attr('data-action');
        var data = $('#deleteProject').find('input').serialize();
        var req = $.ajax({
            method: 'post',
            url: url,
            data: data
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.href) {
                    location.href = resp.href
                }
                if (resp.html) {
                    if ($('.js-index-insert').length) {
                        $('.js-index-insert').html(resp.html);
                    }
                    $('#deleteProject').find('.close').trigger('click');
                }
            }
        })
    });

    var $beforeDeleting;
    $('.wrap_page').on('click', '.control-panel_item_delete.open-popup', function() {
        var id = $(this).attr('data-id');
        $beforeDeleting = $('#' + $(this).attr('data-popup'));
        $beforeDeleting.find('input[name=id]').val(id);
    });

    $('#siteTransfer').on('click', '.confirm-btn', function() {
        var url = $('#siteTransfer').attr('data-action');
        var data = $('#siteTransfer').find('input').serializeArray();
        $('.control-panel_body').find('.control-panel_item_product.selected').each(function( index ) {
            data.push({name: 'ids[]', value: $(this).attr('data-id')});
        });

        var req = $.ajax({
            method: 'post',
            url: url,
            data: data,
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.reload) {
                    location.reload();
                }
                if (resp.href) {
                    location.href = resp.href;
                }
            }
        });
        // $('.control-panel_body').find('.control-panel_item_product.selected').slideUp(200, function() {
        //     $(this).remove();
        //     if(!$('.control-panel_item').find('.control-panel_item_product').length) {
        //         $('.control-panel_body_empty').show();
        //     }
        // });
        // $('.control-panel_item').find('.transfer-block').slideUp(200);
        // $(this).closest('.wrap_popup').find('.close').trigger('click');
    });

    $('.wrap_content').on('change', '.catalog-item .col-26 input[type="checkbox"]', function() {
        if($(this).is(':checked')) {
            $(this).closest('.catalog-item').addClass('selected');
            $(this).closest('.control-panel_item').find('.transfer-block').slideDown(200);
        } else {
            $(this).closest('.catalog-item').removeClass('selected'); 
            if(!$(this).closest('.control-panel_body').find('.catalog-item.selected').length) {
                $(this).closest('.control-panel_item').find('.transfer-block').slideUp(200);          
            }
        }
    });

    $('.wrap_content').on('click', '.open-popup[data-popup=beforeDeletingPlatform]', function() {
        var id = $(this).attr('data-id');
        $('#beforeDeletingPlatform').attr('data-id', id);
    });
    $('#beforeDeletingPlatform .confirm-btn').on('click', function() {
        var req = $.ajax({
            method: 'post',
            url: $('#beforeDeletingPlatform').attr('data-action'),
            data: {'id': $('#beforeDeletingPlatform').attr('data-id'), '_token': CSRF_TOKEN},
        });
        req.done(function(resp) {
            if (resp.success) {
                $beforeDeletingPlatform.closest('.sites-item').remove();
                $(this).closest('.wrap_popup').find('.close').trigger('click');
            }
        })
        req.fail(function(error) {
        })
        req.always(function() {
        });
    });
});